import React from "react";
import { useNavigate } from "react-router-dom";
import "../allcss/blog17.css";
import blogImage from "../Asets/Blog.jpg"; // hero background
import familyImg from "../Asets/blog1717.png"; // detail image (✅ rename or update as per your asset)
import Header from "../components/header";
import Footer from "../components/footer";

const Blog17 = () => {
  const navigate = useNavigate();

  return (
    <>
      <Header />
      <div className="blog-section">
        {/* Hero Section */}
        <div
          className="blog-hero"
          style={{ backgroundImage: `url(${blogImage})` }}
        >
          <div className="blog-overlay">
            <h1 className="blog-title">Our Blog</h1>
            <p className="breadcrumb">
              <span
                style={{ cursor: "pointer", color: "#fff" }}
                onClick={() => navigate("/")}
              >
                Home
              </span>
              <span> / Our Blog</span>
            </p>
          </div>
        </div>

        {/* Blog Detail */}
        <div className="blog-container">
          <h2 className="section-title">
            10 Best Diwali Celebration Ideas for Schools in 2025
          </h2>
          <br />
          <div className="published-badge">Published on: 14 October 2025</div>
          <br />

          <img
            src={familyImg}
            alt="Diwali celebration ideas for schools - Red House School Vadodara"
            className="blog-detail-img"
          />

          <div className="blog-detail-content">
            <p>
              Diwali, the magnificent festival of lights, is a time of immense
              joy, togetherness, and celebration across India. For young
              children, it's a magical period filled with colourful lights,
              delicious sweets, and exciting stories. At school, celebrating
              Diwali can be a wonderful opportunity to teach children about
              culture, tradition, and values in a fun and interactive way.
            </p>

            <p>
              As a leading play school in Harni, Vadodara,{" "}
              <strong>Red House School</strong> believes in making learning a
              joyful and memorable experience. We understand that festivals are
              a powerful tool for holistic development. Here are our top 10
              safe, creative, and engaging Diwali celebration ideas for schools
              in 2025.
            </p>

            <h3>1. Eco-Friendly Diya Decoration</h3>
            <p>
              A classic Diwali activity! Provide children with simple earthen
              diyas and let their creativity shine. Use child-safe, non-toxic
              paints, glitter, mirrors, and beads. This activity is fantastic
              for developing fine motor skills and hand-eye coordination.
              <br />
              <strong>Pro Tip:</strong> Use battery-operated tea lights instead
              of real flames to ensure complete safety for the little ones.
            </p>

            <h3>2. Flower Rangoli Making</h3>
            <p>
              Traditional rangoli powders can be messy for preschoolers.
              Instead, use colourful flower petals, leaves, and coloured rice.
              This sensory activity allows children to explore different
              textures and colours while creating beautiful patterns. It’s a
              wonderful group activity that promotes teamwork.
            </p>

            <h3>3. The Story of Diwali: Puppet Show</h3>
            <p>
              Bring the epic story of Ramayana to life! A simple puppet show
              depicting the return of Lord Rama to Ayodhya is an engaging way to
              teach children the core message of Diwali – the victory of good
              over evil. Using colourful hand puppets and a simple script will
              captivate their attention.
            </p>

            <h3>4. Kandil (Lantern) Making Workshop</h3>
            <p>
              Making paper lanterns or 'kandils' is a delightful craft. Using
              coloured paper, ribbons, and safe glue, children can create their
              own lanterns to decorate the classroom or take home. This activity
              helps improve their cutting, folding, and pasting skills.
            </p>

            <h3>5. No-Bake Sweet Making</h3>
            <p>
              Diwali is incomplete without sweets! Engage children in a no-bake
              cooking activity, like making coconut ladoos or chocolate balls.
              Under supervision, they can help mix ingredients, roll the sweets,
              and decorate them. It's a fun way to introduce basic cooking
              concepts and measurements.
            </p>

            <h3>6. Dress-Up in Traditional Attire</h3>
            <p>
              Encourage students and teachers to come dressed in their favourite
              traditional outfits for a day. You can organize a "show and tell"
              where each child gets to talk about their special clothes. This
              fosters cultural pride and appreciation for diversity.
            </p>

            <h3>7. The Joy of Giving: Charity Drive</h3>
            <p>
              Teach children the value of compassion and sharing, which is a
              core part of the festive spirit. Organize a simple charity drive
              where children can donate old toys, books, or clothes to those in
              need. This instills a sense of empathy and kindness from a young
              age.
            </p>

            <h3>8. Classroom Decoration Party</h3>
            <p>
              Let the children take ownership of their space. Provide them with
              handmade decorations like paper torans (door hangings), strings of
              marigold flowers, and their own crafted diyas to decorate the
              classroom. This builds a sense of community and pride.
            </p>

            <h3>9. Diwali-Themed Music and Dance</h3>
            <p>
              Celebrate with joyful noise! Play festive Diwali songs and teach
              the children simple dance steps. Music and movement are excellent
              for developing gross motor skills and expressing happiness.
            </p>

            <h3>10. An Eco-Friendly Pledge</h3>
            <p>
              In today's world, teaching environmental responsibility is
              crucial. Conclude the celebrations by having the children take a
              pledge for a green, cracker-free Diwali. This teaches them to
              celebrate responsibly and care for our planet.
            </p>

            <h3>Celebrate with Red House School</h3>
            <p>
              At <strong>Red House School</strong>, we integrate these joyful,
              hands-on activities into our curriculum to ensure every child’s
              holistic development. Our celebrations are designed to be safe,
              inclusive, and educational, reflecting our commitment to being the
              best play school in Harni, Vadodara. We believe that learning
              should be filled with discovery and wonder — and what better time
              to spark that than during the beautiful festival of Diwali!
            </p>

            <h3>Contact Us Today!</h3>
            <p>
              <strong>Red House School</strong> is ranked among the top play
              schools in the Harni area, dedicated to fostering a lifelong love
              for learning.
              <br />
              <strong>Location:</strong> A-25, Castle White, Opposite Main,
              Harni Water Tank, Harni Sama Link Road, Vadodara – 390008
              <br />
              <strong>Mobile Number:</strong> +91 77788 51070
              <br />
              <strong>Email:</strong>{" "}
              <a href="mailto:redschoolhousebaroda2025@gmail.com">
                redschoolhousebaroda2025@gmail.com
              </a>
              <br />
              <strong>Website:</strong>{" "}
              <a
                href="https://www.redhouseschoolvadodara.in/"
                target="_blank"
                rel="noreferrer"
              >
                redhouseschoolvadodara.in
              </a>
              <br />
              <strong>Instagram:</strong>{" "}
              <a
                href="https://www.instagram.com/redschoolhousebaroda/"
                target="_blank"
                rel="noreferrer"
              >
                @redschoolhousebaroda
              </a>
              <br />
              <strong>Google Maps:</strong>{" "}
              <a
                href="https://share.google/L2vZh6Cc0gKqWv7wW"
                target="_blank"
                rel="noreferrer"
              >
                Click Here
              </a>
            </p>

            {/* Go Back Button */}
            <div className="back-to-blogs-btn-wrapper">
              <button
                className="back-to-blogs-btn"
                onClick={() => navigate("/blog")}
              >
                Go Back To Blogs
              </button>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Blog17;
